import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useMsal, useIsAuthenticated, AuthenticatedTemplate } from '@azure/msal-react';

const ProtectedRoutes = () => {
  
  console.log("=== ProtectedRoutes Rendered ===");
  
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  const location = useLocation();
  
  // Also check if we have an active account (more reliable during login transitions)
  const activeAccount = instance.getActiveAccount();
  const hasActiveAccount = activeAccount !== null;
  
  console.log("=== ProtectedRoutes: isAuthenticated =", isAuthenticated, ", hasActiveAccount =", hasActiveAccount, " ===");

  // If we're not authenticated and don't have an active account, redirect to login
  if (!isAuthenticated && !hasActiveAccount) {
    console.log("=== ProtectedRoutes: Redirecting to login ===");
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Use AuthenticatedTemplate to ensure we only render when authentication is stable
  return (
    <AuthenticatedTemplate>
      <Outlet />
    </AuthenticatedTemplate>
  );
}

export default ProtectedRoutes;